import React from "react";

const Footer = () => {
  const currentYear=new Date().getFullYear()
  const shortYear=currentYear .toString().slice(-2)
  const nextYear=currentYear+1
  return (
    <footer className="footer">
      <p className="fs-11 text-muted fw-medium text-uppercase mb-0 copyright">
         <span>Copyright © Pharma Tuitions </span>
       {shortYear}-{nextYear}

      </p>
      <span>Developed By: NetSpace Software Solutions Pvt Ltd</span>
    </footer>
  );
};

export default Footer;
